/**
 * News service
 * News service REST API
 *
 * The version of the OpenAPI document: 3.1.0.0
 * Contact: gcb-rt@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface NewsDto {
    storyDateTime?: string;
    source?: string;
    categories?: Array<string>;
    headline?: string;
    storyNumber?: number;
    fileType?: NewsDto.FileTypeEnum;
    newsHref?: string;
    internal?: boolean;
}
export namespace NewsDto {
    export type FileTypeEnum = 'HTML' | 'PDF' | 'TEXT' | 'UNKNOWN';
    export const FileTypeEnum = {
        Html: 'HTML' as FileTypeEnum,
        Pdf: 'PDF' as FileTypeEnum,
        Text: 'TEXT' as FileTypeEnum,
        Unknown: 'UNKNOWN' as FileTypeEnum
    };
}
